import {EvaluatedCell} from 'notebook/tables/excess/Evaluator';
import {BaseTypedValueType, Cell} from 'notebook/tables/TableConstants';
import {StorableInfo} from 'notebook/tables/typed-values/TypedValueTypes';
import {FieldType} from 'schemas/fields/SchemaFieldConstants';
import APIUtil from 'util/APIUtil';

function getGridsFromCell(
  cell: Cell | EvaluatedCell,
  filterFn: (storableId: string) => boolean
): Array<StorableInfo> {
  let typedValue = null;
  if (cell.hasOwnProperty('typedValue')) {
    typedValue = (cell as Cell).typedValue;
  } else {
    typedValue = (cell as EvaluatedCell).value;
  }

  if (typedValue == null) {
    return [];
  }
  if (typedValue.type === BaseTypedValueType.STORABLES) {
    return typedValue.storableSummaries.filter((storable) => filterFn(storable.id));
  }
  if (typedValue.type === FieldType.STORABLE_LINK) {
    return typedValue.targetStorables.filter((storable) => filterFn(storable.id));
  }
  return [];
}

export function getPlatesFromCell(cell: Cell | EvaluatedCell): Array<StorableInfo> {
  return getGridsFromCell(cell, (storableId: string) => APIUtil.isPlate(storableId));
}

export function getBoxesFromCell(cell: Cell | EvaluatedCell): Array<StorableInfo> {
  return getGridsFromCell(cell, (storableId: string) => APIUtil.isBox(storableId));
}
